import React from 'react';
import Button from '../../../components/ui/Button';

const DuplicateVenueModal = ({ duplicateVenues, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-lg shadow-lg max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center">
              <span className="text-yellow-600 text-xl">⚠️</span>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                Potential Duplicate Venue
              </h3>
              <p className="text-sm text-muted-foreground">
                Similar venues found in the system
              </p>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-sm text-foreground mb-4">
              We found {duplicateVenues?.length} venue(s) that might be similar to the one you're creating:
            </p>
            
            <div className="space-y-3 max-h-40 overflow-y-auto">
              {duplicateVenues?.map((venue, index) => (
                <div key={venue?.id || index} className="bg-muted rounded-lg p-3">
                  <div className="font-medium text-foreground text-sm">
                    {venue?.name}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {venue?.address_line_1}, {venue?.city}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-sm text-muted-foreground mb-6">
            <p>
              Would you like to proceed with creating this venue anyway, or would you prefer to select one of the existing venues instead?
            </p>
          </div>

          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={onConfirm}
            >
              Create Anyway
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DuplicateVenueModal;